"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BrandAZSlots;
const react_1 = __importDefault(require("react"));
const BrandAZSlots_module_scss_1 = __importDefault(require("./BrandAZSlots.module.scss"));
const BrandAZSlot_1 = __importDefault(require("./BrandAZSlot/BrandAZSlot"));
// import KevelAnalytics from "../KevelAnalytics/KevelAnalytics";
const NewRelic_1 = __importDefault(require("../NewRelic/NewRelic"));
const REQUIRED_SLOTS = 6;
function BrandAZSlots({ data }) {
    if (data.length !== REQUIRED_SLOTS) {
        return null;
    }
    return (react_1.default.createElement("div", { id: "brand-az-banner-container" },
        react_1.default.createElement("div", { "data-testid": "brand-az-slots-container", className: BrandAZSlots_module_scss_1.default.slotsContainer }, data.map((slot) => (react_1.default.createElement("div", { key: slot.associatedAdvertId },
            react_1.default.createElement(BrandAZSlot_1.default, Object.assign({}, slot)),
            react_1.default.createElement(NewRelic_1.default, { adId: slot.associatedAdvertId, esiType: "brandAZSlot" })))))));
}
